import { Logger } from "../../common/src/utility/logger.class";
// Environment
import { environment } from "../environments/environment";
// Set logging level
Logger.LogLevel = environment.logLevel;
const ɵ0 = environment;
export class AppModule {
}
export { ɵ0 };
